var $dff0e22124d68774$exports = {};
$dff0e22124d68774$exports = {
    "help": `\u{5E2}\u{5D6}\u{5E8}\u{5D4}`,
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`
};


export {$dff0e22124d68774$exports as default};
//# sourceMappingURL=he-IL.mjs.map
